import { render, staticRenderFns } from "./CustomerTemplate.vue?vue&type=template&id=15433752"
import script from "./CustomerTemplate.vue?vue&type=script&lang=js"
export * from "./CustomerTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports